// Common
export const CUSTOM_EVENT_TYPE = 'custom-event'
export type Nullable<T> = T | null | undefined
